import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useFileSize = () => {
    const { t } = useTranslation();

    const getSize = useCallback(
        (bytes: number, decimals: number) => {
            const units = ['b', 'kb', 'mb', 'gb', 'tb', 'pb'];

            let i = 0;

            for (i; bytes > 1024; i++) {
                bytes /= 1024;
            }

            return `${parseFloat(bytes.toFixed(decimals))} ${t(`fileSize.${units[i]}`)}`;
        },
        [t],
    );

    return { getSize };
};
